import { put, select, takeLatest } from 'redux-saga/effects'
import { getDrainSelector } from '../selectors'
import { DrainActionIds, DrainConstants } from '../store/drain.constants'
import { IDrainState } from '../store/drain.types'
import { setField2, setUpdateInputRows } from '../store/drain.actions'
import { IOption } from '../../../../common/common.types'
import { throwPcrException } from '../../../pcr/store/pcr.actions'
import { performWithMutexHOG } from '../../../../services/mutexUtility.service'
import { saveDrain } from '../store/drain.actions'

export function* setField() {
  const drainState: IDrainState = yield select(getDrainSelector)
  const { action, chestSuction, drainSuction, foleyColor, csfColor, location } = drainState
  const actionId = String(action?.id)
  try {
    const convertOptionNametoLowerCase = (option: IOption | null) => {
      if (option) {
        return { ...option, name: option?.name?.toLowerCase() }
      }
      return option
    }

    if (actionId === DrainActionIds.CHEST_TUBE) {
      yield put(setField2(convertOptionNametoLowerCase(chestSuction)))
    } else if (actionId === DrainActionIds.NG_TUBE || actionId === DrainActionIds.OG_TUBE) {
      yield put(setField2(convertOptionNametoLowerCase(drainSuction)))
    } else if (actionId === DrainActionIds.FOLEY) {
      yield put(setField2(convertOptionNametoLowerCase(foleyColor)))
    } else if (actionId === DrainActionIds.VENTRICULOSTOMY) {
      yield put(setField2(convertOptionNametoLowerCase(csfColor)))
    } else if (
      actionId === DrainActionIds.NEEDLE_THORACOSTOMY ||
      actionId === DrainActionIds.SIMPLE_FINGER_THORACOSTOMY
    ) {
      yield put(setField2(location))
    }
    yield put(setUpdateInputRows(true))
    yield put(saveDrain())
  } catch (e) {
    yield put(throwPcrException(`Drain setField() error: ${e}`))
  }
}

export function* setFieldSaga() {
  yield takeLatest(
    [
      DrainConstants.SET_ACTION,
      DrainConstants.SET_CHEST_SUCTION,
      DrainConstants.SET_DRAIN_SUCTION,
      DrainConstants.SET_CSF_COLOR,
      DrainConstants.SET_FOLEY_COLOR,
      DrainConstants.SET_LOCATION,
    ],
    performWithMutexHOG,
    setField
  )
}
